import React from 'react';
import logo from '../assets/hfa-logo.png';
import './LogoBubble.css';

const LogoBubble = () => {
  return (
    <div className="logo-bubble">
      <img src={logo} alt="HFA Logo" />
    </div>
  );
};

export default LogoBubble;
